/** View toggle — Figma 7996:5372: separate buttons, gap 8px, radius-m 8px, p-8px, 24px icon. */
export const VIEW_TOGGLE_GROUP = 'inline-flex items-center gap-2';

export const VIEW_TOGGLE_BUTTON_BASE = [
  'inline-flex items-center justify-center rounded-lg p-2',
  'outline-none transition-colors',
  'focus-visible:ring-1 focus-visible:ring-[#2173FF]/50',
  'disabled:cursor-not-allowed disabled:opacity-50',
].join(' ');

export const VIEW_TOGGLE_BUTTON_ACTIVE =
  'bg-[#2173FF] text-white hover:bg-[#1a5ecc] dark:bg-[#2173FF] dark:hover:bg-[#1a5ecc]';

export const VIEW_TOGGLE_BUTTON_INACTIVE = [
  'border border-[#5c5c5c] bg-white text-content',
  'hover:bg-surface-hover',
  'dark:border-edge dark:bg-surface dark:text-content',
].join(' ');
